import React from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { FormattedMessage } from 'react-intl'
import { Text } from 'src/Components'
import {
  Heading,
  BulletedList,
  Strong
} from 'src/Components/shared/Gem/GemDetail'
import { SERVER_DATE } from 'src/constants/formats'
import { selectRentalPropertyDateOfTargetLTV } from 'src/store/selectors/home/equity'

const ListItem = props => <Text size='s' color='quiet' paragraph {...props} />

const NotEnoughEquityDetail = () => {
  const dateOfTargetLTV = useSelector(selectRentalPropertyDateOfTargetLTV)
  const timeToTargetLTV = moment(dateOfTargetLTV, SERVER_DATE).fromNow()

  return (
    <div>
      <Heading>
        <FormattedMessage
          id='Homeowner.purchasePower.rentalPropertyHeadingNotEnoughEquity'
          defaultMessage='You may want to wait until you have more equity for a larger down payment on an investment property.'
        />
      </Heading>

      <BulletedList>
        <ListItem>
          <FormattedMessage
            id='Homeowner.purchasePower.rentalPropertyNotEnoughEquityOne'
            defaultMessage='Using your current home value, we estimate you may have enough available equity {timeToTargetLTV}'
            values={{
              timeToTargetLTV: <Strong>{timeToTargetLTV}</Strong>
            }}
          />
        </ListItem>
        <ListItem>
          <FormattedMessage
            id='Homeowner.purchasePower.rentalPropertyNotEnoughEquityTwo'
            defaultMessage='Then you could use that equity as a 30% downpayment on a great investment property'
          />
        </ListItem>
        <ListItem>
          <FormattedMessage
            id='Homeowner.purchasePower.rentalPropertyNotEnoughEquityThree'
            defaultMessage='In the meantime, consult your real estate professional to see if investment properties are a good choice for you'
          />
        </ListItem>
      </BulletedList>
    </div>
  )
}

export default NotEnoughEquityDetail
